<nav aria-label="breadcrumb" class="breadcrumb-container">
    <ol class="breadcrumb-list">
        <li *ngFor="let item of items; let last = last; let i = index" class="breadcrumb-item" [class.active]="last">

            <!-- If not last item, show as link -->
            <a *ngIf="!last && item.url" [routerLink]="item.url" class="breadcrumb-link">
                <i *ngIf="item.icon" [class]="item.icon" class="breadcrumb-icon"></i>
                {{ item.label }}
            </a>

            <!-- If last item or no URL, show as text -->
            <span *ngIf="last || !item.url" class="breadcrumb-text">
                <i *ngIf="item.icon" [class]="item.icon" class="breadcrumb-icon"></i>
                {{ item.label }}
            </span>

        </li>
    </ol>
</nav>